import { render, staticRenderFns } from "./CampaignCell.vue?vue&type=template&id=0348ae5c&scoped=true&"
import script from "./CampaignCell.vue?vue&type=script&lang=js&"
export * from "./CampaignCell.vue?vue&type=script&lang=js&"
import style0 from "./CampaignCell.vue?vue&type=style&index=0&id=0348ae5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0348ae5c",
  null
  
)

export default component.exports